// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kAOum","inner":"Footer_inner__3x77c","nextIcon":"Footer_nextIcon__3UDml","innerLeft":"Footer_innerLeft__tDWeZ"};